import React, { useState } from "react";
import DatePicker from "react-datepicker";
import Modal from "../../../../ui/dialogs/Modal";
import EventButton, {
  EventButtonVariant,
} from "../../shared/components/EventButton";

import "react-datepicker/dist/react-datepicker.css";
import eventStore from "../store/eventStore";

interface EventHeaderProps {
  eventName: string;
  eventDate: string;
  eventId: string;
}

const formatEventDate = (isoDateString: string): string => {
  const date = new Date(isoDateString);

  const datePart = date.toLocaleDateString("en-US", {
    weekday: "long",
    month: "long",
    day: "numeric",
  });

  const timePart = date
    .toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    })
    .toLowerCase();

  return `${datePart} • ${timePart} onwards`;
};

const EventHeader: React.FC<EventHeaderProps> = ({
  eventName,
  eventDate,
  eventId,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [startDate, setStartDate] = useState(new Date());

  const openModal = () => {
    setIsOpen(true);
  };

  const handleSave = async () => {
    try {
      await fetch(`/api/v1/sitch-events/edit-event-time/?event=${eventId}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          event_new_start_time: startDate.toISOString(),
        }),
      });
      eventStore.loadEventData(eventId);
    } catch (error) {
      console.error("Error:", error);
    }
    setIsOpen(false);
  };

  const closeModal = () => {
    setIsOpen(false);
  };
  return (
    <div className="text-center">
      <h2 className="text-4xl font-nostalgic text-white leading-tight">
        {eventName}
      </h2>
      <p className="text-sm text-white/80 mt-2">
        <button type="button" onClick={openModal} className="cursor-pointer">
          {formatEventDate(eventDate)}
        </button>
      </p>
      {isOpen && (
        <Modal onClose={closeModal}>
          <DatePicker
            selected={startDate}
            onChange={(date) => setStartDate(date!)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            timeCaption="time"
            dateFormat="MMMM d, yyyy h:mm aa"
            className="min-w-[300px]"
          />
          <div className="mt-2 gap-y-2">
            <EventButton
              onClick={handleSave}
              variant={EventButtonVariant.PRIMARY_BLACK}
              className="w-full"
            >
              Save
            </EventButton>
            <EventButton
              variant={EventButtonVariant.PRIMARY_WHITE}
              className="w-full"
              onClick={closeModal}
            >
              Cancel
            </EventButton>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default EventHeader;
